<textarea [id]="id()"
          class="form-control comment-input"
          [placeholder]="translatePlaceholder()"
          [formControl]="formControl"
          [class.has-validation]="hasErrors()"
          [class.is-invalid]="hasErrors()">
</textarea>
